export default "__VITE_ASSET__Bn1ui9TD__"